export default __webpack_public_path__ + "static/media/breadcrumb_top.18769e5e.svg";